import { Dropdown } from '@carbon/react';
import style from './view-filter-dropdown.module.scss';

export type ViewMode = 'all' | 'mine' | 'saved';

interface ViewFilterDropdownProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const VIEW_OPTIONS = [
  'All Workspaces',
  'My Workspaces',
  'Saved Evaluations',
] as const;

const LABEL_TO_MODE: Record<(typeof VIEW_OPTIONS)[number], ViewMode> = {
  'All Workspaces': 'all',
  'My Workspaces': 'mine',
  'Saved Evaluations': 'saved',
};

const MODE_TO_LABEL: Record<ViewMode, (typeof VIEW_OPTIONS)[number]> = {
  all: 'All Workspaces',
  mine: 'My Workspaces',
  saved: 'Saved Evaluations',
};

/**
 * Dropdown filter for toggling the left panel view between all workspaces,
 * the current user's workspaces, and saved evaluations.
 *
 * @param {ViewFilterDropdownProps} props - Component props.
 * @return {JSX.Element} The view filter dropdown.
 */
export const ViewFilterDropdown = ({
  value,
  onChange,
}: ViewFilterDropdownProps): JSX.Element => {
  return (
    <Dropdown
      id="view-filter"
      size="sm"
      titleText="View"
      label=""
      items={[...VIEW_OPTIONS]}
      selectedItem={MODE_TO_LABEL[value]}
      className={style.dropdown}
      onChange={({ selectedItem }: { selectedItem: string | null }) => {
        if (selectedItem && selectedItem in LABEL_TO_MODE) {
          onChange(LABEL_TO_MODE[selectedItem as keyof typeof LABEL_TO_MODE]);
        }
      }}
    />
  );
};
